import React from 'react';
import styles from './Stepper.module.css';

class Stepper extends React.Component {
  render() {
    const { steps = [], current = 0 } = this.props;

    return (
      <div className={styles.stepper}>
        {steps.map((step, i) => {
          const done    = i < current;
          const active  = i === current;
          const future  = i > current;

          return (
            <React.Fragment key={i}>
              <div className={[
                styles.step,
                done   ? styles.done   : '',
                active ? styles.active : '',
                future ? styles.future : '',
              ].join(' ')}>
                <div className={styles.circle}>
                  {done
                    ? <span className="material-symbols-rounded" style={{ fontSize: 13 }}>check</span>
                    : i + 1}
                </div>
                <div className={styles.label}>{step}</div>
              </div>
              {i < steps.length - 1 && (
                <div className={[styles.connector, done ? styles.connDone : ''].join(' ')} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

export default Stepper;
